/**
 * @module entry
 * 登録フローのデータの保存・更新・削除
 */

const state = {
  entryInfo: null,
  selectedLike: {
    selected: [],
    comment: ''
  }
}

const getters = {
  entryInfo: state => state.entryInfo,
  selectedLike: state => state.selectedLike
}

const mutations = {
  ADD_ENTRY_INFO(state, val) {
    if (state.entryInfo !== null) {
      state.entryInfo = null
    }
    state.entryInfo = val
  },
  ADD_LIKE_LIST(state, val) {
    if (state.selectedLike !== null) {
      state.selectedLike = null
    }
    state.selectedLike = val
  },
  REMOVE_ENTRY_INFO(state) {
    state.entryInfo = null
  }
}

const actions = {
  addEntryInfo({commit}, val) {
    commit('ADD_ENTRY_INFO', val)
  },
  addLikeList({commit}, val) {
    commit('ADD_LIKE_LIST', val)
  },
  removeEntryInfo({commit}) {
    commit('REMOVE_ENTRY_INFO')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
